
import AdminLayout from "../../commponents/layout/adminLayout";
import { useEffect, useState } from "react";
import type { TableColumn } from "../../commponents/table/types";
import { Pencil, Trash2 } from "lucide-react";

import { createsubCategory, deletesubCategoryById, editsubCategory, getsubCategory, getsubCategoryById } from "../../api/subCategoryApi";
import Modal from "../../commponents/Modal";
import { getCategory } from "../../api/categoryApi";
import DataTable from "../../commponents/table/DataTable";
import { showConfirm, showError, showSuccess } from "../../utils/ alert";

interface subCategory {
  id: number;
  subCategoryName: string;
  categoryName: string;
}

interface Category {
  id: number;
  categoryName: string;
}

export default function SubsubCategory() {

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [subCategory, setsubCategory] = useState<subCategory[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [subCategoryName, setsubCategoryName] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [categoryId, setCategoryId] = useState<number>();
  const [categoryList, setCategoryList] = useState<Category[]>([]);
    
  


  const columns: TableColumn<subCategory>[] = [
    {
      key: "categoryName",
      title: "Category",
    },
    {
      key: "subCategoryName",
      title: "Sub Category Name",
    },

    {
      key: "id",
      title: "Action",
      render: (row) => (
        <div className="flex items-center gap-2">
          <button
            onClick={() => handleEdit(row.id)}
            className="rounded-lg bg-yellow-100 p-2 text-yellow-600 hover:bg-yellow-200">
            <Pencil size={18} />
          </button>

          <button
            onClick={() => handleDelete(row.id)}
            className="rounded-lg bg-red-100 p-2 text-red-600 hover:bg-red-200">
            <Trash2 size={18} />
          </button>
        </div>
      ),
    },
  ];
  

  const fetchsubCategory = async () => {
    try {
      setLoading(true);
  
      const response = await getsubCategory({
        page: currentPage,
        limit: pageSize,
      });
  
      setsubCategory(response.data.subCategoryList);
  
      setTotalPages(response.data.pagination.totalPages);
  
      setTotalData(response.data.pagination.totalData);
    } catch (error) {
      showError(
        "Failed",
        "Failed to Load data."
    );
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchsubCategory();
  }, [currentPage, pageSize]);
    
  useEffect(() => {
   
  }, [subCategory]);
  
 const handleSave = async () => {
   try {
     if (!subCategoryName.trim()) {
       showError("subCategory name is required");
       return;
     }

     if (isEdit && selectedId !== null) {
       await editsubCategory(selectedId, {
         category_id: categoryId,
         subcategory_name: subCategoryName,
         status: "Active",
       });

     await showSuccess("subCategory updated successfully.");
     } else {
       
       if (!categoryId) {
         showError("Category is required");
         return;
       }

       if (!subCategoryName) {
         showError("subcategory_name is required");
         return;
       }

       await createsubCategory({
         category_id: categoryId,
         subcategory_name: subCategoryName,
         status: "Active",
       });

       await showSuccess("subCategory created successfully.");
     }

     await fetchsubCategory();

     handleCloseModal();
   } catch (error) {
     showError(
        "Failed",
        "Failed to Load data."
    );
     showError("Failed to save subCategory.");
   }
 };

  const handleEdit = async (id: number) => {
   
    try {
      const { data } = await getsubCategoryById(id);
      
  
      setCategoryId(data.data.category_id);

     setsubCategoryName(data.data.subcategory_name);
     setSelectedId(id);
     setIsEdit(true);
     setOpenModal(true);
    } catch (error) {
      showError(
        "Failed",
        "Failed to Load data."
    );
    }
   
  };

     const handleDelete = async (id: number) => {
       try {
         const confirmed = await showConfirm(
           "Are you sure you want to delete this subCategory?"
         );

         if (!confirmed) return;

         await deletesubCategoryById(id);

         await fetchsubCategory();

        await showSuccess("subCategory deleted successfully.");

         // fetchProducts(); // refresh list
       } catch (error) {
         showError(
        "Failed",
        "Failed to Load data."
    );
         showError("Failed to delete subCategory.");
       }
     };
  
  const handleCloseModal = () => {
    setOpenModal(false);
    setsubCategoryName("");
    setSelectedId(null);
    setIsEdit(false);
  };
  
  const handleAdd = () => {
    setIsEdit(false);
    setSelectedId(null);
    setsubCategoryName("");
    setOpenModal(true);
  };

  const fetchCategory = async () => {
    try {
      const response = await getCategory({
        page: 1,
        limit: 9999,
      });

      setCategoryList(response.data.categoryList);
    } catch (error) {
      showError(
        "Failed",
        "Failed to Load data."
    );
    }
  };

  useEffect(() => {
    fetchCategory();
  }, []);
 
 
    return (
      <AdminLayout>
        <div className="bg-white rounded-3xl p-6">
          <DataTable
            title="Sub Category List"
            columns={columns}
            data={subCategory}
            onAdd={handleAdd}
            showSearch={false}
            showFilter={false}
            pagination={{
              currentPage,
              totalPages,
              pageSize,
              onPageChange: setCurrentPage,
              onPageSizeChange: (size) => {
                setPageSize(size);
                setCurrentPage(1);
              },
            }}
          />

          <Modal
            open={openModal}
            title={isEdit ? "Edit subCategory" : "Add subCategory"}
            onClose={handleCloseModal}>
            <div className="space-y-5">
              <div>
                <label className="block mb-2 font-semibold">Category</label>

                <select
                  value={categoryId}
                  onChange={(e) => setCategoryId(Number(e.target.value))}
                  className="w-full rounded-lg border border-gray-300 px-4 py-2">
                  <option value="">-- Select Category --</option>

                  {categoryList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.categoryName}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block mb-2 font-semibold">
                  SubCategory Name
                </label>

                <input
                  type="text"
                  value={subCategoryName}
                  onChange={(e) => setsubCategoryName(e.target.value)}
                  placeholder="type here"
                  className="w-full rounded-lg border border-gray-300 px-4 py-2"
                />
              </div>

              <div className="flex justify-end gap-3">
                <button
                  onClick={handleCloseModal}
                  className="rounded-lg bg-red-600 px-5 py-2 text-white">
                  Cancel
                </button>

                <button
                  onClick={handleSave}
                  className="rounded-lg bg-green-600 px-5 py-2 text-white">
                  {isEdit ? "Update" : "Save"}
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </AdminLayout>
    );
  }


